/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components
import { Link, Navigate, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import CoverLayout from "../components/CoverLayout";

// Images
import bgImage from "assets/images/Bg.jpeg";
import { useState } from "react";
import { withAuthContext } from "context/Auth";
import { validateEmail } from "utils/validation";
import swal from "sweetalert";

function Cover({ loginAdmin }) {
	const navigate = useNavigate();
	const [Loading, setLoading] = useState(false);

	const [state, setState] = useState({ email: "", password: "" });
	const [errors, setErrors] = useState({});
	const [serverError, setServerError] = useState("");

	const handleChange = (name, value) => {
		setState({ ...state, [name]: value });
	};

	const validateForm = () => {
		const newErrors = {};
		const emailErr = validateEmail(state.email);
		if (emailErr) newErrors.email = emailErr;
		// For login, just check if password exists (no strength validation)
		if (!state.password) newErrors.password = 'Password is required';
		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const handleSubmit = async () => {
		if (!validateForm()) return;
		setLoading(true);
		setServerError("");
		const result = await loginAdmin(state.email, state.password);
		setLoading(false);
		if (result.success) {
			swal({
				text: result.message || 'Login successful',
				button: { text: 'Ok', closeModal: true },
				icon: 'success',
				time: 2500
			});
			navigate("/");
			setTimeout(() => window.location.reload(), 300);
		} else {
			swal({
				text: result.message || 'Login failed',
				button: { text: 'Ok', closeModal: true },
				icon: 'error',
				time: 3000
			});
			setServerError(result.message || 'Login failed');
		}
	};
	return (
		<CoverLayout image={bgImage} coverHeight="100vh">
			<Card>
				<MDBox
					variant="gradient"
					bgColor="info"
					borderRadius="lg"
					coloredShadow="success"
					mx={2}
					mt={-3}
					p={3}
					mb={1}
					textAlign="center"
				>
					<MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
						Login to your Account
					</MDTypography>
					<MDTypography display="block" variant="button" color="white" my={1}>
						Enter your email and password to proceed
					</MDTypography>
				</MDBox>
				<MDBox pt={4} pb={3} px={3}>
					<MDBox component="form" role="form">
						<MDBox mb={2}>
							<MDInput
								type="email"
								label="Email"
								variant="standard"
								fullWidth
								value={state.email}
								onChange={(e) => handleChange("email", e.target.value)}
								error={Boolean(errors.email)}
							/>
						</MDBox>
						<MDBox mb={2}>
							<MDInput
								type="password"
								label="Password"
								variant="standard"
								fullWidth
								value={state.password}
								onChange={(e) => handleChange("password", e.target.value)}
								error={Boolean(errors.password)}
							/>
							{serverError && (
								<MDTypography variant="caption" color="error">{serverError}</MDTypography>
							)}
						</MDBox>
						<MDBox mt={4} mb={1}>
							<MDButton
								variant="gradient"
								color="info"
								fullWidth
								onClick={() => {
									if (!Loading) {
										handleSubmit();
									} else {
										swal({
											text: "Please Let This Task Complete First",
											button: {
												text: "Ok",
												closeModal: true
											},
											icon: "warning",
											time: 3000
										});
									}
								}}
							>
								sign in
							</MDButton>
						</MDBox>
					</MDBox>
				</MDBox>
			</Card>
		</CoverLayout>
	);
}

export default withAuthContext(Cover);
